var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 16.2898L15.4004 10.2898C15.6795 10.0056 15.8359 9.62319 15.8359 9.22484C15.8359 8.8265 15.6795 8.44407 15.4004 8.15984C15.1179 7.88136 14.7371 7.72525 14.3404 7.72525C13.9437 7.72525 13.5629 7.88136 13.2804 8.15984L7.28039 14.1598C7.00071 14.4386 6.7788 14.7697 6.62738 15.1344C6.47597 15.499 6.39803 15.89 6.39803 16.2848C6.39803 16.6797 6.47597 17.0706 6.62738 17.4353C6.7788 17.8 7.00071 18.1311 7.28039 18.4098C7.84289 18.9716 8.60539 19.2872 9.40039 19.2872C10.1954 19.2872 10.9579 18.9716 11.5204 18.4098L17.5204 12.4098C17.9392 11.9919 18.2714 11.4954 18.4981 10.9489C18.7248 10.4024 18.8414 9.81651 18.8414 9.22484C18.8414 8.63318 18.7248 8.04732 18.4981 7.5008C18.2714 6.95427 17.9392 6.45782 17.5204 6.03984C16.6736 5.19896 15.5287 4.72705 14.3354 4.72705C13.1421 4.72705 11.9971 5.19896 11.1504 6.03984L5.15039 12.0398",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.321d44ef5b55a07f5f93ba0e3120d96f.svg";
export { ForwardRef as ReactComponent };